import { render, staticRenderFns } from "./savePost.vue?vue&type=template&id=15634a94&"
import script from "./savePost.vue?vue&type=script&lang=js&"
export * from "./savePost.vue?vue&type=script&lang=js&"
import style0 from "./savePost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports